import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import CssBaseline from '@material-ui/core/CssBaseline';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Copyright from '../../components/Copyright';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  }
});

const enhancer = compose(
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const resetMailSending = enhancer(({ classes, handleRedirect }) => {
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h3" align="center">
          ごちめし
          <br />
          管理システム
        </Typography>
        <Avatar className={classes.avatar}>
          <MailOutlineIcon />
        </Avatar>
        <Typography component="h2" variant="h5" paragraph>
          パスワード再設定メール送信
        </Typography>
        <Typography variant="p" paragraph align="center">
          パスワード再設定用のメールを送信しました。
          <br />
          メールを確認して、再設定用リンクを選択してください。
        </Typography>
        <Button
          color="primary"
          onClick={() => {
            handleRedirect('/reset_password');
          }}
        >
          パスワード再設定へ(※検証用)
        </Button>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
});

export default withRouter(withStyles(styles)(resetMailSending));
